import { FaqSettingMinimal } from '@karakuri-web/faq-type'
import { SearchLayout } from '@karakuri-web/faq-type'

import { Search } from '../components'
import { useFaqData } from '../contexts/FaqDataContext'
import { useFaqRouting } from '../contexts/FaqRoutingContext'

/**
 * SearchWidget用の設定インターフェース
 */
export interface SearchWidgetSettings extends FaqSettingMinimal {
  waitMs?: {
    search?: number | null
  } | null
  searchType?: string | null
  words?: {
    search?: {
      resultMessage?: {
        success?: string | null
        error?: string | null
      } | null
    } | null
  } | null
}

interface Props<T extends SearchWidgetSettings = SearchWidgetSettings> {
  data: { settingYaml: T }
  layout: SearchLayout
}

/**
 * キーワード検索ウィジェット
 * 検索フォームを表示し、FAQを検索する
 */
export function SearchWidget<T extends SearchWidgetSettings = SearchWidgetSettings>({
  layout,
  data,
}: Props<T>) {
  const { navigate } = useFaqRouting()
  const faqData = useFaqData()
  const botId = data.settingYaml.botId || ''
  const tenantId = data.settingYaml.tenantId

  const handleSearched = (inputValue: string, result: { id: string; title: string }[]) => {
    faqData.sendSearchEvent({ inputValue, result })
    faqData.recordSearched({ botId, text: inputValue, tenantId })
  }

  return (
    <div className="faq-panel faq-panel-search">
      <h3 className="faq-panel-title">{layout.title || 'キーワード検索'}</h3>
      <Search
        onClick={navigate}
        onSearched={handleSearched}
        searchWaitMs={data.settingYaml.waitMs?.search ?? 5000}
        search={async inputValue => {
          const result = await faqData.searchFaq({
            botId,
            tenantId,
            inputValue: inputValue || '',
            searchType: data.settingYaml.searchType,
          })
          return { data: result }
        }}
        resultMessage={{
          success: data.settingYaml.words?.search?.resultMessage?.success || undefined,
          error: data.settingYaml.words?.search?.resultMessage?.error || undefined,
        }}
      />
    </div>
  )
}
